/* eslint-disable */
import { useState, useRef, useEffect } from 'react'
import './Kyc.css'
import Grid from "@mui/material/Grid2";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Selects from 'react-select';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import toast from 'react-hot-toast';
import Passoprt1 from '../../../Images/verify-identity/Passoprt.png';
import Passoprt2 from '../../../Images/verify-identity/passport-blur.png';
import successImage from '../../../Images/success-tict-ait.webp'
import { InputError } from '../../Errors/ErrorText';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { ToastSuccess, ToastError } from "../../../CustomToaster/CustomToaster.js";
import { getUserDetail } from '../../../Actions/UserDetailAction';
import { updateKYC } from '../../../Services/user';



const steps = [
    {
        label: 'Personal Details',
        description: `For each ad campaign that you create, you can control how much
                you're willing to spend on clicks and conversions, which networks
                and geographical locations you want your ads to show on, and more.`,
    },
    {
        label: 'Address Details',
        description:
            'An ad group contains one or more ads which target a shared set of keywords.',
    },
    {
        label: 'Identity Details',
        description: `Try out different ad text to see what brings in the most customers,
                and learn how to enhance your ads using features like ad extensions.
                If you run into any problems with your ads, find out how to tell if
                they're running and how to resolve approval issues.`,
    },
    {
        label: 'Documents Upload',
        description:
            'An ad group contains one or more ads which target a shared set of keywords.',
    },
    // {
    //     label: 'Requests',
    //     description:
    //         'An ad group contains one or more ads which target a shared set of keywords.',
    // },
];

const countries = [
    { value: 'IN', label: 'India', icon: 'in' },
    // { value: 'US', label: 'United States', icon: 'us' },
    // { value: 'SA', label: 'South Africa', icon: 'sa' },
    // { value: 'GB', label: 'United Kingdom', icon: 'gb' },
    // { value: 'CA', label: 'Canada', icon: 'ca' },
    // { value: 'FR', label: 'France', icon: 'fr' },
    // { value: 'DE', label: 'Germany', icon: 'de' }
];


const customStyles = {
    control: (provided) => ({
        ...provided,
        border: "1px solid var(--color-InputLine)",
        boxShadow: "none",
        "&:hover": {
            border: "1px solid var(--color-InputLine)",
        },
    }),

    option: (provided, state) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
        background: state.isSelected
            ? "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%)"
            : state.isFocused
                ? "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%)"
                : "white",
        color: state.isSelected || state.isFocused ? "#000" : "#000",
        cursor: "pointer",
    }),

    singleValue: (provided) => ({
        ...provided,
        color: "#fff",
        display: 'flex',
        alignItems: 'center',
    }),

    menu: (provided) => ({
        ...provided,
        borderRadius: "8px",
        overflow: "hidden",
    }),
};



function Kyc() {

    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    const [activeStep, setActiveStep] = useState(0);
    const [selectedCountry, setSelectedCountry] = useState({ value: 'IN', label: 'India', icon: 'in' });
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [uploadSts, setUploadSts] = useState(false)

    const formatOptionLabel = ({ label, icon }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={`https://flagcdn.com/48x36/${icon}.png`} alt={label} style={{ marginRight: 10, width: '24px' }} />

            {label}
        </div>
    );

    const handleBack = () => {
        setAddressDetailsErr({
            address1: "",
            address2: "",
            city: "",
            state: "",
            country: "",
            postalCode: "",
            addressProof: ""
        })
        setVerifyIdentityErr({
            country: "",
            docType: "",
            idnumber: "",
            img1: "",
            img2: ""
        })
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        navigate('/dashboard')
    };

    const proof = [
        {
            name: 'Passport', subName: 'One side',
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M4.6325 1.35938C4.30844 1.42047 4.07469 1.70734 4.08 2.03937C4.08 3.91203 2.55266 5.43937 0.68 5.43937C0.305469 5.43937 0 5.74484 0 6.11937V27.8794C0 28.2539 0.305469 28.5594 0.68 28.5594C2.55266 28.5594 4.08 30.0867 4.08 31.9594C4.08 32.3339 4.38547 32.6394 4.76 32.6394H29.24C29.6145 32.6394 29.92 32.3339 29.92 31.9594C29.92 30.0867 31.4473 28.5594 33.32 28.5594C33.6945 28.5594 34 28.2539 34 27.8794V6.11937C34 5.74484 33.6945 5.43937 33.32 5.43937C31.4473 5.43937 29.92 3.91203 29.92 2.03937C29.92 1.66484 29.6145 1.35938 29.24 1.35938H4.76C4.73875 1.35938 4.7175 1.35938 4.69625 1.35938C4.675 1.35938 4.65375 1.35938 4.6325 1.35938ZM5.29125 2.71937H28.7087C29.0195 4.77 30.5894 6.33984 32.64 6.65062V27.3481C30.5894 27.6589 29.0195 29.2287 28.7087 31.2794H5.29125C4.98047 29.2287 3.41062 27.6589 1.36 27.3481V6.65062C3.41062 6.33984 4.98047 4.77 5.29125 2.71937ZM7.48 8.90312L9.3075 17.0631V17.1269H10.8162L12.7075 8.96687H11.2838L10.6038 12.5794C10.3992 13.5303 10.2717 14.5556 10.1363 15.5756H10.0725C9.93703 14.5556 9.71922 13.4639 9.58375 12.5794L8.90375 8.90312H7.48ZM14.0675 8.90312V17.0631H15.3638V8.90312H14.0675ZM19.1675 8.90312C17.672 8.90312 16.7875 9.86469 16.7875 11.1556C16.7875 12.0402 17.4755 12.7759 18.36 13.3869C19.04 13.8623 19.4438 14.2156 19.4438 14.8956C19.4438 15.5756 19.048 16.0431 18.2325 16.0431C17.757 16.0431 17.2072 15.9077 16.9363 15.7031L16.66 16.7869C16.9309 16.9914 17.5366 17.1269 18.1475 17.1269C19.643 17.1269 20.6763 16.2423 20.6763 14.7469C20.6763 13.9314 20.2725 13.1319 19.2525 12.4519C18.437 11.9764 18.0837 11.6178 18.0837 11.0069C18.0837 10.4623 18.4184 9.98687 19.1675 9.98687C19.643 9.98687 19.983 10.1277 20.1875 10.2631L20.4 9.17937C20.1955 9.04391 19.712 8.90312 19.1675 8.90312ZM23.3325 8.90312L21.4837 17.0631H22.78L23.1838 14.9594H24.82L25.2238 17.0631H26.52L24.82 8.90312H23.3325ZM24.0125 10.1994H24.0763C24.1453 10.7439 24.217 11.4823 24.3525 12.0269L24.6712 13.8756H23.3962L23.7362 12.0269C23.8053 11.5514 23.9434 10.7439 24.0125 10.1994ZM5.9925 20.3994C5.61797 20.4339 5.34172 20.7686 5.37625 21.1431C5.41078 21.5177 5.74547 21.7939 6.12 21.7594H27.88C28.1244 21.762 28.3528 21.6345 28.4777 21.422C28.5998 21.2095 28.5998 20.9492 28.4777 20.7367C28.3528 20.5242 28.1244 20.3967 27.88 20.3994H6.12C6.09875 20.3994 6.0775 20.3994 6.05625 20.3994C6.035 20.3994 6.01375 20.3994 5.9925 20.3994ZM5.9925 24.4794C5.61797 24.5139 5.34172 24.8486 5.37625 25.2231C5.41078 25.5977 5.74547 25.8739 6.12 25.8394H19.04C19.2844 25.842 19.5128 25.7145 19.6377 25.502C19.7598 25.2895 19.7598 25.0292 19.6377 24.8167C19.5128 24.6042 19.2844 24.4767 19.04 24.4794H6.12C6.09875 24.4794 6.0775 24.4794 6.05625 24.4794C6.035 24.4794 6.01375 24.4794 5.9925 24.4794ZM22.9925 24.4794C22.618 24.5139 22.3417 24.8486 22.3762 25.2231C22.4108 25.5977 22.7455 25.8739 23.12 25.8394H27.88C28.1244 25.842 28.3528 25.7145 28.4777 25.502C28.5998 25.2895 28.5998 25.0292 28.4777 24.8167C28.3528 24.6042 28.1244 24.4767 27.88 24.4794H23.12C23.0988 24.4794 23.0775 24.4794 23.0562 24.4794C23.035 24.4794 23.0138 24.4794 22.9925 24.4794Z" fill="#231F20" />
            </svg>
        },
        {
            name: 'Residence permit', subName: 'One side',
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M4.6325 1.35938C4.30844 1.42047 4.07469 1.70734 4.08 2.03937C4.08 3.91203 2.55266 5.43937 0.68 5.43937C0.305469 5.43937 0 5.74484 0 6.11937V27.8794C0 28.2539 0.305469 28.5594 0.68 28.5594C2.55266 28.5594 4.08 30.0867 4.08 31.9594C4.08 32.3339 4.38547 32.6394 4.76 32.6394H29.24C29.6145 32.6394 29.92 32.3339 29.92 31.9594C29.92 30.0867 31.4473 28.5594 33.32 28.5594C33.6945 28.5594 34 28.2539 34 27.8794V6.11937C34 5.74484 33.6945 5.43937 33.32 5.43937C31.4473 5.43937 29.92 3.91203 29.92 2.03937C29.92 1.66484 29.6145 1.35938 29.24 1.35938H4.76C4.73875 1.35938 4.7175 1.35938 4.69625 1.35938C4.675 1.35938 4.65375 1.35938 4.6325 1.35938ZM5.29125 2.71937H28.7087C29.0195 4.77 30.5894 6.33984 32.64 6.65062V27.3481C30.5894 27.6589 29.0195 29.2287 28.7087 31.2794H5.29125C4.98047 29.2287 3.41062 27.6589 1.36 27.3481V6.65062C3.41062 6.33984 4.98047 4.77 5.29125 2.71937ZM7.48 8.90312L9.3075 17.0631V17.1269H10.8162L12.7075 8.96687H11.2838L10.6038 12.5794C10.3992 13.5303 10.2717 14.5556 10.1363 15.5756H10.0725C9.93703 14.5556 9.71922 13.4639 9.58375 12.5794L8.90375 8.90312H7.48ZM14.0675 8.90312V17.0631H15.3638V8.90312H14.0675ZM19.1675 8.90312C17.672 8.90312 16.7875 9.86469 16.7875 11.1556C16.7875 12.0402 17.4755 12.7759 18.36 13.3869C19.04 13.8623 19.4438 14.2156 19.4438 14.8956C19.4438 15.5756 19.048 16.0431 18.2325 16.0431C17.757 16.0431 17.2072 15.9077 16.9363 15.7031L16.66 16.7869C16.9309 16.9914 17.5366 17.1269 18.1475 17.1269C19.643 17.1269 20.6763 16.2423 20.6763 14.7469C20.6763 13.9314 20.2725 13.1319 19.2525 12.4519C18.437 11.9764 18.0837 11.6178 18.0837 11.0069C18.0837 10.4623 18.4184 9.98687 19.1675 9.98687C19.643 9.98687 19.983 10.1277 20.1875 10.2631L20.4 9.17937C20.1955 9.04391 19.712 8.90312 19.1675 8.90312ZM23.3325 8.90312L21.4837 17.0631H22.78L23.1838 14.9594H24.82L25.2238 17.0631H26.52L24.82 8.90312H23.3325ZM24.0125 10.1994H24.0763C24.1453 10.7439 24.217 11.4823 24.3525 12.0269L24.6712 13.8756H23.3962L23.7362 12.0269C23.8053 11.5514 23.9434 10.7439 24.0125 10.1994ZM5.9925 20.3994C5.61797 20.4339 5.34172 20.7686 5.37625 21.1431C5.41078 21.5177 5.74547 21.7939 6.12 21.7594H27.88C28.1244 21.762 28.3528 21.6345 28.4777 21.422C28.5998 21.2095 28.5998 20.9492 28.4777 20.7367C28.3528 20.5242 28.1244 20.3967 27.88 20.3994H6.12C6.09875 20.3994 6.0775 20.3994 6.05625 20.3994C6.035 20.3994 6.01375 20.3994 5.9925 20.3994ZM5.9925 24.4794C5.61797 24.5139 5.34172 24.8486 5.37625 25.2231C5.41078 25.5977 5.74547 25.8739 6.12 25.8394H19.04C19.2844 25.842 19.5128 25.7145 19.6377 25.502C19.7598 25.2895 19.7598 25.0292 19.6377 24.8167C19.5128 24.6042 19.2844 24.4767 19.04 24.4794H6.12C6.09875 24.4794 6.0775 24.4794 6.05625 24.4794C6.035 24.4794 6.01375 24.4794 5.9925 24.4794ZM22.9925 24.4794C22.618 24.5139 22.3417 24.8486 22.3762 25.2231C22.4108 25.5977 22.7455 25.8739 23.12 25.8394H27.88C28.1244 25.842 28.3528 25.7145 28.4777 25.502C28.5998 25.2895 28.5998 25.0292 28.4777 24.8167C28.3528 24.6042 28.1244 24.4767 27.88 24.4794H23.12C23.0988 24.4794 23.0775 24.4794 23.0562 24.4794C23.035 24.4794 23.0138 24.4794 22.9925 24.4794Z" fill="#231F20" />
            </svg>
        },
        {
            name: 'Driving license', subName: 'Both sides',
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none">
                <path d="M4.08035 6.61914C2.58488 6.61914 1.36035 7.84367 1.36035 9.33914V25.6591C1.36035 27.1546 2.58488 28.3791 4.08035 28.3791H29.9203C31.4158 28.3791 32.6403 27.1546 32.6403 25.6591V9.33914C32.6403 7.84367 31.4158 6.61914 29.9203 6.61914H4.08035ZM4.08035 7.97914H29.9203C30.68 7.97914 31.2803 8.57945 31.2803 9.33914V25.6591C31.2803 26.4188 30.68 27.0191 29.9203 27.0191H4.08035C3.32066 27.0191 2.72035 26.4188 2.72035 25.6591V9.33914C2.72035 8.57945 3.32066 7.97914 4.08035 7.97914ZM11.4966 10.6991C9.98785 10.7257 8.92269 11.4402 8.50035 12.4416C8.12582 13.3341 8.20019 14.3409 8.41535 15.3104C8.41004 15.3184 8.42066 15.3237 8.41535 15.3316C8.29582 15.5362 8.18957 15.839 8.20285 16.2029C8.22145 16.7262 8.41535 17.1193 8.62785 17.3716C8.73941 17.5045 8.78723 17.5177 8.88285 17.5841C8.99176 17.9215 9.11129 18.2641 9.2866 18.4979C9.40348 18.6546 9.53629 18.729 9.64785 18.8379C9.65582 19.1274 9.66379 19.3957 9.64785 19.6666C9.59207 19.7755 9.49379 19.8924 9.18035 20.0491C8.8377 20.2218 8.33832 20.3971 7.82035 20.6229C7.30238 20.8487 6.75254 21.1302 6.29035 21.6004C5.82816 22.0705 5.49082 22.7452 5.44035 23.5766C5.42973 23.7652 5.49613 23.9485 5.62363 24.084C5.75379 24.2221 5.93176 24.2991 6.12035 24.2991H17.0003C17.1889 24.2991 17.3669 24.2221 17.4971 24.084C17.6246 23.9485 17.691 23.7652 17.6804 23.5766C17.6299 22.7452 17.2925 22.0705 16.8303 21.6004C16.3682 21.1302 15.8183 20.8487 15.3004 20.6229C14.7824 20.3971 14.283 20.2218 13.9404 20.0491C13.6136 19.8845 13.4994 19.757 13.4516 19.6454C13.4383 19.3824 13.4649 19.1195 13.4729 18.8379C13.6004 18.7157 13.7624 18.6387 13.8766 18.4766C14.0439 18.2349 14.1449 17.8923 14.2379 17.5629C14.4663 17.3929 14.8966 17.0263 14.8966 16.2666C14.8966 15.9479 14.7372 15.754 14.6416 15.5229C14.801 14.9996 15.0029 14.2187 14.9179 13.3766C14.87 12.9171 14.7425 12.4443 14.4079 12.0379C14.1316 11.7005 13.6694 11.5146 13.1754 11.4429C12.7822 11.0126 12.235 10.6991 11.5179 10.6991C11.5099 10.6991 11.5046 10.6991 11.4966 10.6991ZM11.5179 12.0591C11.5285 12.0591 11.5285 12.0591 11.5391 12.0591C11.9694 12.0698 12.2589 12.3195 12.3041 12.3991C12.4236 12.6037 12.6414 12.7338 12.8779 12.7391C13.1833 12.7391 13.2577 12.8029 13.3454 12.9091C13.433 13.0154 13.5286 13.2305 13.5579 13.5254C13.6163 14.1151 13.4357 14.9305 13.3241 15.2679C13.2471 15.4937 13.2949 15.746 13.4516 15.9266C13.4436 15.9346 13.5366 16.0887 13.5366 16.2666C13.5366 16.3915 13.3241 16.5854 13.3241 16.5854C13.1541 16.6863 13.0399 16.859 13.0054 17.0529C12.9735 17.276 12.8752 17.5124 12.7504 17.6904C12.6255 17.8684 12.4582 18.0065 12.4954 17.9879C12.2669 18.0995 12.1182 18.3279 12.1129 18.5829C12.1129 18.9813 12.0624 19.3691 12.1129 19.9216C12.1208 19.9801 12.1341 20.0359 12.1554 20.0916C12.3785 20.6866 12.8752 21.024 13.3454 21.2604C13.8155 21.4968 14.2963 21.6801 14.7479 21.8766C15.1994 22.0732 15.5899 22.2884 15.8529 22.5566C15.9432 22.6496 15.9564 22.8276 16.0229 22.9391H7.09785C7.16426 22.8276 7.17754 22.6496 7.26785 22.5566C7.53082 22.2884 7.92129 22.0732 8.37285 21.8766C8.82441 21.6801 9.30519 21.4968 9.77535 21.2604C10.2455 21.024 10.7449 20.6893 10.9654 20.0916C10.9866 20.0359 10.9999 19.9801 11.0079 19.9216C11.0583 19.3665 11.0079 18.9813 11.0079 18.5829C11.0105 18.3385 10.8804 18.1101 10.6679 17.9879C10.6785 17.9985 10.6732 18.0012 10.6466 17.9879C10.6068 17.9507 10.4739 17.8285 10.3704 17.6904C10.2243 17.4965 10.0968 17.2335 10.0729 17.0529C10.0383 16.8298 9.89488 16.6385 9.69035 16.5429C9.69035 16.5429 9.71426 16.5535 9.6691 16.5004C9.62395 16.4473 9.57082 16.3649 9.56285 16.1391C9.56019 16.0701 9.6266 15.9691 9.6266 15.9691C9.7966 15.7965 9.86301 15.5441 9.7966 15.3104C9.55754 14.3913 9.52566 13.5148 9.7541 12.9729C9.97988 12.4363 10.381 12.0857 11.5179 12.0591ZM19.5928 13.4191C19.2183 13.4537 18.9421 13.7884 18.9766 14.1629C19.0111 14.5374 19.3458 14.8137 19.7204 14.7791H27.8804C28.1247 14.7818 28.3532 14.6543 28.478 14.4418C28.6002 14.2293 28.6002 13.969 28.478 13.7565C28.3532 13.544 28.1247 13.4165 27.8804 13.4191H19.7204C19.6991 13.4191 19.6779 13.4191 19.6566 13.4191C19.6353 13.4191 19.6141 13.4191 19.5928 13.4191ZM19.5928 16.8191C19.2183 16.8537 18.9421 17.1884 18.9766 17.5629C19.0111 17.9374 19.3458 18.2137 19.7204 18.1791H27.8804C28.1247 18.1818 28.3532 18.0543 28.478 17.8418C28.6002 17.6293 28.6002 17.369 28.478 17.1565C28.3532 16.944 28.1247 16.8165 27.8804 16.8191H19.7204C19.6991 16.8191 19.6779 16.8191 19.6566 16.8191C19.6353 16.8191 19.6141 16.8191 19.5928 16.8191ZM19.5928 20.2191C19.2183 20.2537 18.9421 20.5884 18.9766 20.9629C19.0111 21.3374 19.3458 21.6137 19.7204 21.5791H27.8804C28.1247 21.5818 28.3532 21.4543 28.478 21.2418C28.6002 21.0293 28.6002 20.769 28.478 20.5565C28.3532 20.344 28.1247 20.2165 27.8804 20.2191H19.7204C19.6991 20.2191 19.6779 20.2191 19.6566 20.2191C19.6353 20.2191 19.6141 20.2191 19.5928 20.2191Z" fill="#231F20" />
            </svg>
        },
        {
            name: 'NationalId', subName: 'Both sides',
            svg: <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path d="M4.75977 1.35938V32.6394H5.43977H29.2398V1.35938H4.75977ZM6.11977 2.71937H27.8798V31.2794H6.11977V2.71937ZM16.3198 6.11937V9.02266L13.807 7.57102L13.127 8.74773L15.6411 10.1994L13.127 11.651L13.807 12.8277L16.3198 11.3761V14.2794H17.6798V11.3761L20.1926 12.8277L20.8726 11.651L18.3584 10.1994L20.8726 8.74773L20.1926 7.57102L17.6798 9.02266V6.11937H16.3198ZM9.51977 17.6794V19.0394H24.4798V17.6794H9.51977ZM9.51977 21.7594V23.1194H24.4798V21.7594H9.51977ZM9.51977 25.8394V27.1994H12.2398H14.2798H17.6798V25.8394H14.2798H12.2398H9.51977Z" fill="black" />
            </svg>
        },
    ]

    useEffect(() => {
        if (window.localStorage.getItem("status")) {
            window.localStorage.getItem("status") == "KYC Verified Successfully" ? toast.success("KYC Verified Successfully") : toast.error(window.localStorage.getItem("status"))
            window.localStorage.removeItem("status")
        }
    }, [])

    const [selectDoc, setSelectDoc] = useState(false)

    const handleSelectDoc = (row) => {
        setVerifyIdentity({ ...verifyIdentity, docType: { name: row.name, subname: row.subName } })
        setVerifyIdentityErr({ ...verifyIdentityErr, docType: '' })
        setSelectDoc(true);
        setFormErrors((prev) => ({ ...prev, document: "" }))
    }
    const [selectUpload, setselectUpload] = useState(false);

    const handleHighlight = (i) => {
        setselectUpload(i)
    }

    const [addressDetailsErr, setAddressDetailsErr] = useState({
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        addressProof: ""
    })

    const [verifyIdentity, setVerifyIdentity] = useState({
        country: "",
        docType: "",
        idnumber: "",
        img1: "",
        img2: ""
    })

    const [verifyIdentityErr, setVerifyIdentityErr] = useState({
        country: "",
        docType: "",
        idnumber: "",
        img1: "",
        img2: ""
    })

    const handleReset2 = () => {

        setSelectDoc(false)
        setVerifyIdentity({
            ...verifyIdentity,
            docType: "",
            idnumber: "",
            img1: "",
            img2: ""
        });
        setVerifyIdentityErr({
            country: "",
            docType: "",
            idnumber: "",
            img1: "",
            img2: ""
        })
    }

    // image uploader
    const fileInputRef = useRef(null);
    const [imageUrl, setImageUrl] = useState(null);

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormErrors({ ...formErrors, frontFile: "" });
        if (file) {
            setFrontFile(file);
            setImageUrl(URL.createObjectURL(file));
        }
    };

    const handleRemove = () => {
        setImageUrl(null);
        setFrontFile(null)

        // fileInputRef.current.value = null; // reset the input
    };

    // image uploader end

    // image uploaderback
    const fileInputRefback = useRef(null);
    const [imageUrlback, setImageUrlback] = useState(null);
    const [frontFile, setFrontFile] = useState(null);
    const [backFile, setBackFile] = useState(null);

    const handleClickback = () => {
        if (fileInputRefback.current) {
            fileInputRefback.current.click();
        }
    };

    const handleFileChangeback = (e) => {
        const file = e.target.files[0];
        setFormErrors({ ...formErrors, backFile: "" });
        if (file) {
            setBackFile(file);
            setImageUrlback(URL.createObjectURL(file));
        }
    };

    const handleRemoveback = () => {
        setImageUrlback(null);
        setBackFile(null)
        fileInputRefback.current.value = null;
    };


    // custom code
    const [formData, setFormData] = useState({
        userName: '',
        firstName: '',
        profileimg: "",
        lastName: "",
        email: "",
        phone: "",
        DOB: null,
        panNumber: null,
        address: "",
        city: "",
        countryVal: "IN",
        country: "US",
        nationality: "Indian",
        state: "",
        postalCode: "",
        street: "",
        companyName: "",
        registerDate: null,
        companyEmail: ''
    });
    const { userDetailData, userDetailStatus } = useSelector((state) => state.user);

    const [userDob, setUserDob] = useState(null)
    const today = dayjs();
    const maxDate = today.subtract(15, "year");
    const minDate = today.subtract(100, "year");
    const [kycLoading, setKycLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [errors, setErrors] = useState({
        otp: "",
        password: ""
    });


    const MAX_NAME_LENGTH = 30;

    useEffect(() => {
        if (userDetailStatus === true) {
            setFormData((prev) => ({ ...prev, email: userDetailData?.email }))
        }
    }, [userDetailStatus])

    const handleChange = async (e) => {
        const { name, value } = e.target;

        //  NAME VALIDATION first, last
        if (name === "firstName" || name === "lastName") {
            //  block spaces
            if (value.includes(" ")) {
                setFormErrors((prev) => ({ ...prev, [name]: "Only one word is allowed (no spaces)" }));
                return;
            }

            //  allow only letters
            if (!/^[A-Za-z]*$/.test(value)) {
                setFormErrors((prev) => ({ ...prev, [name]: "Name can contain only letters" }));
                return;
            }

            //  block after 30 letters
            if (value.length > MAX_NAME_LENGTH) {
                setFormErrors((prev) => ({ ...prev, [name]: "Name cannot exceed 30 letters" }));
                return; //  stop updating state
            }

            //  clear error when valid
            setFormErrors((prev) => ({ ...prev, [name]: "" }));
        }

        const updatedValue =
            name === "panNumber" ? value.trim().toUpperCase() : value;

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));
    };

    const validateFocus = (e = null) => {
        let isValid = true;
        const errors = {};

        const validateDOB = (value) => {
            if (!value) return "Date of Birth required";

            const dob = new Date(value);
            if (isNaN(dob.getTime())) {
                return "Invalid Date of Birth";
            }

            const today = new Date();

            const minDate = new Date();
            minDate.setFullYear(today.getFullYear() - 70);

            const maxDate = new Date();
            maxDate.setFullYear(today.getFullYear() - 15);

            if (dob >= today) {
                return "Date of Birth must be in the past";
            }

            if (dob < minDate || dob > maxDate) {
                return "Age must be between 15 and 70 years";
            }

            return "";
        };


        // 🔹 FIELD LEVEL VALIDATION (onChange / onBlur)
        if (e) {
            const { name, value } = e.target;
            const trimmed = value.trim();
            if (name === "firstName") {
                if (!trimmed) {
                    errors.firstName = "First name is required";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(trimmed)) {
                    errors.firstName = "First name can contain only letters";
                    isValid = false;
                } else if (trimmed.length > 30) {
                    errors.firstName = "First name cannot exceed 30 characters";
                    isValid = false;
                }
                else if (trimmed.length < 2) {
                    errors.firstName = "First name must be at least 2 characters long";
                    isValid = false;
                }
            }
            if (name === "lastName") {
                if (!trimmed) {
                    errors.lastName = "Last Name is required";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(trimmed)) {
                    errors.lastName = "Last name can contain only letters";
                    isValid = false;
                } else if (trimmed.length > 30) {
                    errors.lastName = "Last name cannot exceed 30 characters";
                    isValid = false;
                } else if (trimmed.length < 2) {
                    errors.lastName = "Last name must be at least 2 characters long";
                    isValid = false;
                }
            }


            if (name === "street" && !trimmed) {
                errors.street = "Flat / Street is required";
                isValid = false;
            }

            if (name === "city") {
                if (!trimmed) {
                    errors.city = "City is required";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(trimmed)) {
                    errors.city = "City can contain only letters";
                    isValid = false;
                }
            }

            if (name === "state") {
                if (!trimmed) {
                    errors.state = "State is required";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(trimmed)) {
                    errors.state = "State can contain only letters";
                    isValid = false;
                }
            }

            if (name === "postalCode") {
                if (!trimmed) {
                    errors.postalCode = "Postal / ZIP code is required";
                    isValid = false;
                } else if (!/^\d{1,10}$/.test(trimmed)) {
                    errors.postalCode = "Postal / ZIP code must be 1–10 digits";
                    isValid = false;
                }
            }

            setFormErrors(prev => ({
                ...prev,
                [name]: errors[name] || "",
            }));

            return isValid;
        }

        // 🔹 STEP LEVEL VALIDATION (on NEXT)
        if (activeStep == 0) {
            if (!formData.firstName) {
                errors.firstName = "First name is required";
                isValid = false;
            } else {
                if (formData.firstName.length < 2) {
                    errors.firstName = "First name must be at least 2 characters long";
                    isValid = false;
                } else if (formData.firstName.length > 30) {
                    errors.firstName = "First name cannot exceed 30 characters";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(formData.firstName)) {
                    errors.firstName = "First name can contain only letters";
                    isValid = false;
                }
            }
            if (!formData.lastName) {
                errors.lastName = "Last name is required";
                isValid = false;
            } else {
                if (formData.lastName.length < 2) {
                    errors.lastName = "Last name must be at least 2 characters long";
                    isValid = false;
                } else if (formData.lastName.length > 30) {
                    errors.lastName = "Last name cannot exceed 30 characters";
                    isValid = false;
                } else if (!/^[A-Za-z ]+$/.test(formData.lastName)) {
                    errors.lastName = "Last name can contain only letters";
                    isValid = false;
                }
            }
            //  DOB submit-time validation
            const dobError = validateDOB(formData.DOB);
            if (dobError) {
                errors.dob = dobError;
                isValid = false;
            }
        }

        if (activeStep === 1) {
            if (!formData.street) {
                errors.street = "Flat / Street is required";
                isValid = false;
            }
            if (!formData.city) {
                errors.city = "City is required";
                isValid = false;
            }
            if (!formData.state) {
                errors.state = "State is required";
                isValid = false;
            }
            if (!formData.postalCode) {
                errors.postalCode = "Postal / ZIP code is required";
                isValid = false;
            } else if (!/^\d{1,10}$/.test(formData.postalCode)) {
                errors.postalCode = "Postal / ZIP code must be 1–10 digits";
                isValid = false;
            }
        }

        //  STEP 2 – COUNTRY + DOCUMENT (THIS WAS MISSING)
        if (activeStep === 2) {
            if (!selectedCountry.value) {
                errors.country = "Country is required";
                isValid = false;
            }
            if (!selectDoc) {
                errors.document = "Select and upload any of the document";
                isValid = false;
            }
        }

        //  STEP 3 – FRONT IMAGE
        if (activeStep === 3) {
            if (selectDoc && !frontFile) {
                errors.frontFile = "Upload the front image";
                isValid = false;
            }
            if (selectDoc && !backFile) {
                errors.backFile = "Upload the back image";
                isValid = false;
            }
        }
        setFormErrors(errors);
        return isValid;
    };

    const handleNext = () => {
        setErrors({})
        if (activeStep === 0) {
            if (validateFocus()) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);

            }
        }
        else if (activeStep === 1) {
            if (validateFocus()) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);

            }
        }
        else if (activeStep === 2) {
            if (validateFocus()) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);

            }
        }
        else if (activeStep === 3) {
            if (validateFocus()) {
                handleSubmitKyc();
            }
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);

        }
    };

    // const changeHandler = (selected) => {
    //     setFormData({
    //         ...formData,
    //         country: selected?.value,
    //         countryVal: selected?.value,
    //     });
    //     setFormErrors({
    //         ...formErrors,
    //         country: "",
    //     });
    //     setSelectedCountry(selected)
    // };

    const handleSubmitKyc = async () => {
        if ((selectDoc === null || frontFile === null || backFile === null)) {
            let formErrors = {};
            let isValid = true;

            if (selectDoc === null) {
                formErrors.document = "Select the document";
                isValid = false;
            }
            if (selectDoc != "" && frontFile === null) {
                formErrors.frontFile = "Select the front image";
                isValid = false;
            }
            if (selectDoc != "" && backFile === null) {
                formErrors.backFile = "Select the back image";
                isValid = false;
            }

            setFormErrors((prev) => ({ ...prev, formErrors }));
            return isValid;
        }

        else {
            const userId = userDetailData?._id;
            const finalData = new FormData();

            if (frontFile) finalData.append("frontImage_0", frontFile);
            if (backFile) finalData.append("backImage_0", backFile);

            const address = {
                'street': formData.street,
                'city': formData.city,
                'state': formData.state,
                'country': formData.country,
                'postalCode': formData.postalCode
            }

            const dob = formData?.DOB ? formData?.DOB : userDob;

            finalData.append("address", JSON.stringify(address));
            finalData.append("userId", userId);
            finalData.append("firstName", formData.firstName);
            finalData.append("lastName", formData.lastName);
            finalData.append("dob", dob);
            finalData.append("nationality", formData.nationality);
            finalData.append("country", formData.country);
            finalData.append("phoneNumber", formData.phone);
            finalData.append("documentType", verifyIdentity?.docType?.name);
            try {
                setKycLoading(true)
                const response = await updateKYC(finalData);

                if (response.data.success) {
                    dispatch(getUserDetail());
                    ToastSuccess({ message: response.data.message || "KYC submitted successfull" });
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                } else {
                    ToastError({ message: response.data.message || "KYC submission failed" });
                }
            } catch (error) {
                ToastError({ message: "Failed to submit KYC" });
                console.error(error);
            } finally {
                setKycLoading(false)
            }
        }
    };

    return (
        <div className='merchant-tools-main kyc'>
            <div className="display-2 mb-10" >
                <h2 className="gold-color">KYC Verification</h2>
            </div>
            <Grid container className='' sx={{ height: '88%', justifyContent: 'center' }}>
                <>
                    {(userDetailData?.kyc?.status === "Rejected" ?
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                            <div className='success-box'>
                                <p style={{ color: "#ef564d", fontWeight: 700, fontSize: '16px' }}>Your previous KYC submission was rejected.
                                    Please submit your KYC again to complete the verification. </p>
                            </div>
                        </Grid>
                        : null)
                    }
                    {((!userDetailData?.kyc || (userDetailData?.kyc?.status === "Start" || userDetailData?.kyc?.status === "Rejected") && userDetailData?.kyc?.verify === false)) &&
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3, xl: 3 }} className='dcBk'>
                            <div className="kyc-left-main" style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between', flexDirection: 'column', height: '100%' }}>
                                <Stepper activeStep={activeStep} orientation="vertical" className='kyc-stepper'>
                                    {steps.map((step) => (
                                        <Step key={step.label}>
                                            <StepLabel
                                                className='label-txt'
                                            >
                                                {step.label}
                                            </StepLabel>

                                        </Step>
                                    ))}
                                </Stepper>

                            </div>
                        </Grid>
                    }

                    {
                        (!userDetailData?.kyc || (userDetailData?.kyc?.status === "Start" || userDetailData?.kyc?.status === "Rejected") && userDetailData?.kyc.verify === false)
                            ?

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9, xl: 9 }} className='kyx-right card-box'>
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    {steps.map((step, index) => (
                                        <Step key={step.label}>
                                            <StepContent>
                                                {index === 0 &&
                                                    <>
                                                        <div className="add-deta">
                                                            Personal Details
                                                        </div>
                                                        <Grid container spacing={2}>
                                                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                                <div className='display-1 kyx-inptxt mt-20'>First Name</div>
                                                                <div className='input-common mt-5'>
                                                                    <TextField
                                                                        fullWidth
                                                                        name="firstName"
                                                                        value={formData.firstName}
                                                                        onChange={handleChange}
                                                                        onInput={validateFocus}
                                                                        error={!!formErrors?.firstName}
                                                                    />

                                                                    <InputError error={formErrors?.firstName} />
                                                                </div>
                                                            </Grid>
                                                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                                <div className='display-1 kyx-inptxt mt-20'>Last Name</div>
                                                                <div className='input-common mt-5'>
                                                                    <TextField
                                                                        fullWidth
                                                                        name="lastName"
                                                                        value={formData.lastName}
                                                                        onChange={handleChange}
                                                                        onInput={validateFocus}
                                                                        error={!!formErrors?.lastName}
                                                                    />

                                                                    <InputError error={formErrors?.lastName} />
                                                                </div>
                                                            </Grid>

                                                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                                <div className='display-1 kyx-inptxt'>Email *</div>
                                                                <div className='input-common mt-5'>
                                                                    <TextField type='email' placeholder='Enter email address' fullWidth
                                                                        inputProps={{ readOnly: true }}
                                                                        value={formData.email}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                                <div className="input-common date-pick">
                                                                    <label>DOB</label>
                                                                    <div className='mt-5'>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DemoContainer components={['DatePicker']}>
                                                                                <DatePicker
                                                                                    label=""
                                                                                    value={formData.DOB ? dayjs(formData.DOB) : null}
                                                                                    onChange={(newValue) => {
                                                                                        if (!newValue) {
                                                                                            setFormData(prev => ({ ...prev, DOB: null }));
                                                                                            setUserDob(null);
                                                                                            setFormErrors(prev => ({ ...prev, dob: "Date of Birth is required" }));
                                                                                            return;
                                                                                        }

                                                                                        const formattedDate = newValue.format("YYYY-MM-DD");
                                                                                        const age = dayjs().diff(newValue, 'year');

                                                                                        if (age < 15 || age > 70) {
                                                                                            setFormErrors(prev => ({ ...prev, dob: "Age must be between 15 and 70 years" }));
                                                                                        } else {
                                                                                            setFormErrors(prev => ({ ...prev, dob: "" }));
                                                                                            setFormData(prev => ({ ...prev, DOB: formattedDate }));
                                                                                            setUserDob(formattedDate);
                                                                                        }
                                                                                    }}
                                                                                    onBlur={() => {
                                                                                        if (!formData.DOB) {
                                                                                            setFormErrors(prev => ({ ...prev, dob: "Date of Birth is required" }));
                                                                                        } else {
                                                                                            const age = dayjs().diff(dayjs(formData.DOB), 'year');
                                                                                            if (age < 15 || age > 70) {
                                                                                                setFormErrors(prev => ({ ...prev, dob: "Age must be between 15 and 70 years" }));
                                                                                            } else {
                                                                                                setFormErrors(prev => ({ ...prev, dob: "" }));
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    minDate={dayjs("1966-01-01")}
                                                                                    maxDate={dayjs("2009-12-31")}
                                                                                    openTo="year"
                                                                                    views={["year", "month", "day"]}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            inputProps: {
                                                                                                readOnly: true,
                                                                                            },
                                                                                            onKeyDown: (e) => e.preventDefault(),
                                                                                        },
                                                                                    }}
                                                                                    sx={{
                                                                                        width: '100%',
                                                                                        '& .MuiInputAdornment-root': {
                                                                                            marginLeft: '0px',
                                                                                        },
                                                                                        '& .MuiSvgIcon-root': {
                                                                                            color: '#DA9B31',
                                                                                        },
                                                                                        '& .MuiInputAdornment-root': {
                                                                                            marginLeft: 0,
                                                                                            position: 'absolute',
                                                                                            right: '10px',
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </DemoContainer>
                                                                        </LocalizationProvider>
                                                                        <InputError error={formErrors.dob} />
                                                                    </div>
                                                                </div>
                                                            </Grid>

                                                        </Grid>
                                                    </>
                                                }

                                                {index === 1 &&
                                                    <>
                                                        <div className="">
                                                            <div className="add-deta">
                                                                Address details
                                                            </div>
                                                            <Grid container spacing={2}>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                    <div className='display-1 kyx-inptxt mt-20'>Flat No / Street Name</div>
                                                                    <div className='input-common mt-10'>
                                                                        <TextField fullWidth placeholder='Flat no / Street Name'
                                                                            onChange={handleChange}
                                                                            value={formData.street}
                                                                            name='street'
                                                                            error={!!formErrors?.street}
                                                                            onInput={validateFocus}
                                                                        />
                                                                        <InputError error={formErrors.street} />

                                                                    </div>
                                                                </Grid>

                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                    <div className='display-1 kyx-inptxt'>City</div>
                                                                    <div className='input-common mt-10'>
                                                                        <TextField fullWidth placeholder='Enter City name'
                                                                            name='city'
                                                                            value={formData.city}
                                                                            error={!!formErrors?.city}
                                                                            onInput={validateFocus}
                                                                            onChange={(e) => {
                                                                                let value = e.target.value;
                                                                                // value = value.replace(/[^a-zA-Z ]/g, "");
                                                                                value = value.replace(/[^a-zA-Z ]/g, "").replace(/^\s+/, "");
                                                                                if (value.trim() !== "") {
                                                                                    setFormData({ ...formData, city: value });
                                                                                } else {
                                                                                    setFormData({ ...formData, city: "" }); // or keep it empty
                                                                                }
                                                                                setFormErrors({
                                                                                    ...formErrors,
                                                                                    city: ""
                                                                                })
                                                                            }}

                                                                        />
                                                                        <InputError error={formErrors.city} />

                                                                    </div>
                                                                </Grid>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                    <div className='display-1 kyx-inptxt'>State</div>
                                                                    <div className='input-common mt-10'>
                                                                        <TextField fullWidth placeholder='Enter State name'
                                                                            name="state"
                                                                            value={formData.state}
                                                                            error={!!formErrors?.state}
                                                                            onInput={validateFocus}

                                                                            onChange={(e) => {
                                                                                let value = e.target.value;
                                                                                // value = value.replace(/[^a-zA-Z ]/g, "");
                                                                                value = value.replace(/[^a-zA-Z ]/g, "").replace(/^\s+/, "");
                                                                                if (value.trim() !== "") {
                                                                                    setFormData({ ...formData, state: value });
                                                                                } else {
                                                                                    setFormData({ ...formData, state: "" }); // or keep it empty
                                                                                }
                                                                                setFormErrors({
                                                                                    ...formErrors,
                                                                                    state: ""
                                                                                })
                                                                            }}
                                                                        />
                                                                        <InputError error={formErrors.state} />

                                                                    </div>
                                                                </Grid>

                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                    <div className='display-1 kyx-inptxt'>Postal / Zip code</div>
                                                                    <div className='input-common mt-10'>
                                                                        <TextField
                                                                            fullWidth
                                                                            name="postalCode"
                                                                            placeholder='Enter Postal / Zip Code'
                                                                            value={formData.postalCode}
                                                                            onChange={(e) => {
                                                                                let value = e.target.value.replace(/\D/g, ""); // digits only
                                                                                if (value.length > 10) value = value.slice(0, 10); // max 10 digits
                                                                                setFormData(prev => ({ ...prev, postalCode: value }));
                                                                                setFormErrors(prev => ({ ...prev, postalCode: "" }));
                                                                            }}
                                                                            onBlur={(e) => validateFocus(e)}
                                                                            error={!!formErrors.postalCode}
                                                                        />
                                                                        <InputError error={formErrors.postalCode} />

                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>

                                                    </>}

                                                {index === 2 &&
                                                    <>
                                                        {
                                                            // !selectDoc ?
                                                            <div className="">
                                                                <div className="add-deta">
                                                                    Verify your identity
                                                                </div>

                                                                <Grid container spacing={2}>
                                                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                        <div className='display-1 kyx-inptxt mt-30'>Select the issuing country of your identity document</div>
                                                                        <div className="input-common mt-10 margin-top selectctry-wrapper">
                                                                            <div className="select-country">
                                                                                <Selects
                                                                                    fullWidth
                                                                                    value={selectedCountry}
                                                                                    // onChange={changeHandler}
                                                                                    options={countries}
                                                                                    styles={customStyles}
                                                                                    formatOptionLabel={formatOptionLabel}
                                                                                    isSearchable={false}
                                                                                    disabled
                                                                                    placeholder="Select a country..."
                                                                                    className='selectctry'
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {selectedCountry && <div className="add-d-des margin-t-10px">
                                                                            To verify your identity, you can upload one of the following documents:
                                                                        </div>}
                                                                    </Grid>

                                                                </Grid>
                                                                <InputError error={formErrors.country} />



                                                                <div className="margin-top">
                                                                    <Grid container spacing={2}>
                                                                        {selectedCountry ? proof.map((row, i) => {
                                                                            return (
                                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                                                                                    <div
                                                                                        className={`${selectUpload === i ? "highlight-upload upl-docmainHvr cursor" : ""} ${hoveredIndex === i ? "upl-docmainHvr cursor" : "upl-docmain cursor"}`}
                                                                                        key={i}
                                                                                        onMouseEnter={() => { setHoveredIndex(i); }}
                                                                                        onMouseLeave={() => { setHoveredIndex(null); }}
                                                                                        onClick={() => { handleSelectDoc(row); handleHighlight(i); setselectUpload(i) }}
                                                                                    >
                                                                                        <div className="display-2">
                                                                                            <div className="display-1">
                                                                                                {row.svg}
                                                                                                <div className={hoveredIndex === i ? "upl-txthvr" : "upl-txt"}>
                                                                                                    {row.name}
                                                                                                    <div className={hoveredIndex === i ? "upl-deschvr" : "upl-desc"}>
                                                                                                        {row.subName}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                                                <path d="M9.28957 15.8793L13.1696 11.9993L9.28957 8.1193C8.89957 7.7293 8.89957 7.0993 9.28957 6.7093C9.67957 6.3193 10.3096 6.3193 10.6996 6.7093L15.2896 11.2993C15.6796 11.6893 15.6796 12.3193 15.2896 12.7093L10.6996 17.2993C10.3096 17.6893 9.67957 17.6893 9.28957 17.2993C8.90957 16.9093 8.89957 16.2693 9.28957 15.8793Z" fill={hoveredIndex === i ? "#fff" : "#231F20"} />
                                                                                            </svg>
                                                                                        </div>
                                                                                    </div>
                                                                                </Grid>


                                                                            )
                                                                        }) : <></>}
                                                                    </Grid>
                                                                    <InputError error={formErrors.document} />

                                                                </div>

                                                            </div>
                                                            // :

                                                        }
                                                    </>
                                                }



                                                {
                                                    index === 3 &&
                                                    <Grid container spacing={2}>
                                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>


                                                            <Grid container justifyContent="center" spacing={1}>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                    <div className='setting-titles '>
                                                                        <h2>Upload front side and back side</h2>
                                                                    </div>
                                                                </Grid>
                                                                <input
                                                                    type="file"
                                                                    accept="image/png, image/jpeg, image/jpg"
                                                                    ref={fileInputRef}
                                                                    key={45876}
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                            const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
                                                                            if (!allowedTypes.includes(file.type)) {
                                                                                setFormErrors(prev => ({ ...prev, frontFile: "Only PNG/JPG/JPEG files are allowed" }));
                                                                                e.target.value = null; // reset the input
                                                                                return;
                                                                            }
                                                                            handleFileChange(e); // proceed with valid file
                                                                            setFormErrors(prev => ({ ...prev, frontFile: "" })); // clear error
                                                                        }
                                                                    }}
                                                                    className="upload-input"
                                                                />

                                                                <input
                                                                    type="file"
                                                                    accept="image/png, image/jpeg, image/jpg"
                                                                    ref={fileInputRefback}
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                            const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
                                                                            if (!allowedTypes.includes(file.type)) {
                                                                                setFormErrors(prev => ({ ...prev, backFile: "Only PNG/JPG/JPEG files are allowed" }));
                                                                                e.target.value = null;
                                                                                return;
                                                                            }
                                                                            handleFileChangeback(e);
                                                                            setFormErrors(prev => ({ ...prev, backFile: "" }));
                                                                        }
                                                                    }}
                                                                    className="upload-input"
                                                                />
                                                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                    <div className="identity-document-img">
                                                                        <img src={Passoprt1} alt="Passoprt" />
                                                                    </div>
                                                                    <div className='assistant-cnt-nuber-list identity-document-list mt-20 '>
                                                                        <h4 className='mb-10'><span className='green'>  Do </span></h4>
                                                                        <ul className='text-start'>
                                                                            <li> Photo is clear and sharp</li>
                                                                            <li>Details can be read clearly</li>
                                                                            <li>High or good photo quality</li>
                                                                            <li>All 4 corners of the document are visible</li>
                                                                        </ul>
                                                                    </div>

                                                                </Grid>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                    <div className="identity-document-img">
                                                                        <img src={Passoprt2} alt="Passoprt" />
                                                                    </div>
                                                                    <div className='assistant-cnt-nuber-list identity-document-list mt-20 '>
                                                                        <h4 className='mb-10'><span className='red'>Don't</span></h4>
                                                                        <ul className='text-start'>
                                                                            <li> Photo is blurry and not focused </li>
                                                                            <li>Details cannot be read clearly</li>
                                                                            <li>Poor photo quality (too dark or bright)</li>
                                                                            <li>Not all corners are visible</li>
                                                                        </ul>
                                                                    </div>

                                                                </Grid>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                    <div className="upload-box mt-20">
                                                                        {!imageUrl ? (
                                                                            <div onClick={handleClick}>
                                                                                <div className="upload-icon">📤</div>
                                                                                <p className="upload-text">Upload the front of your document</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="preview-container">
                                                                                <img src={imageUrl} alt="Preview" className="preview-image" />
                                                                                <button className="close-button-img" onClick={handleRemove}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                                                                                        <path d="M27.9211 7.0768C22.2874 1.44315 13.0425 1.44315 7.40883 7.0768C1.77518 12.7104 1.77518 21.9554 7.40883 27.589C13.0425 33.2227 22.143 33.2227 27.7766 27.589C33.4103 21.9554 33.5547 12.7104 27.9211 7.0768ZM21.7096 23.3999L17.665 19.3553L13.6203 23.3999L11.5979 21.3776L15.6426 17.3329L11.5979 13.2883L13.6203 11.2659L17.665 15.3106L21.7096 11.2659L23.732 13.2883L19.6873 17.3329L23.732 21.3776L21.7096 23.3999Z" fill="url(#paint0_linear_823_5579)" />
                                                                                        <defs>
                                                                                            <linearGradient id="paint0_linear_823_5579" x1="3.18359" y1="17.2207" x2="32.0748" y2="17.2207" gradientUnits="userSpaceOnUse">
                                                                                                <stop stopColor="#ef564d" />
                                                                                                <stop offset="0.390184" stopColor="#ef564d" />
                                                                                                <stop offset="0.765024" stopColor="#ef564d" />
                                                                                                <stop offset="0.979932" stopColor="#ef564d" />
                                                                                            </linearGradient>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <InputError error={formErrors.frontFile} />
                                                                </Grid>
                                                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                    <div className="upload-box mt-20">
                                                                        {!imageUrlback ? (
                                                                            <div onClick={handleClickback}>
                                                                                <div className="upload-icon">📤</div>
                                                                                <p className="upload-text">Upload the back of your document</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="preview-container">
                                                                                <img src={imageUrlback} alt="Preview" className="preview-image" />
                                                                                <button className="close-button-img" onClick={handleRemoveback}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                                                                                        <path d="M27.9211 7.0768C22.2874 1.44315 13.0425 1.44315 7.40883 7.0768C1.77518 12.7104 1.77518 21.9554 7.40883 27.589C13.0425 33.2227 22.143 33.2227 27.7766 27.589C33.4103 21.9554 33.5547 12.7104 27.9211 7.0768ZM21.7096 23.3999L17.665 19.3553L13.6203 23.3999L11.5979 21.3776L15.6426 17.3329L11.5979 13.2883L13.6203 11.2659L17.665 15.3106L21.7096 11.2659L23.732 13.2883L19.6873 17.3329L23.732 21.3776L21.7096 23.3999Z" fill="url(#paint0_linear_823_5579)" />
                                                                                        <defs>
                                                                                            <linearGradient id="paint0_linear_823_5579" x1="3.18359" y1="17.2207" x2="32.0748" y2="17.2207" gradientUnits="userSpaceOnUse">
                                                                                                <stop stopColor="#ef564d" />
                                                                                                <stop offset="0.390184" stopColor="#ef564d" />
                                                                                                <stop offset="0.765024" stopColor="#ef564d" />
                                                                                                <stop offset="0.979932" stopColor="#ef564d" />
                                                                                            </linearGradient>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                    <InputError error={formErrors.backFile} />

                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        {
                                                            verifyIdentity?.docType?.subname == "Both sides" &&
                                                            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>



                                                                <div className='invalid-error'>{verifyIdentityErr?.img2 != '' ? <p style={{ textAlign: "left" }}>{verifyIdentityErr?.img2}</p> : ''}</div>
                                                            </Grid>
                                                        }


                                                    </Grid>
                                                }

                                                {index === 4 && <>
                                                    <div className="">
                                                        <div className="text-center">
                                                            <img src={successImage} alt="success" />
                                                        </div>
                                                        <div className="verif-sucs margin-t-10px text-center">
                                                            {/* Verification passed successfully */}
                                                            Your submitted KYC details are currently under review. Once verified by the admin, you'll receive confirmation upon approval

                                                        </div>

                                                    </div>
                                                </>}
                                                <Box sx={{ mb: 2, mt: 6 }}>
                                                    <div className='display-1' style={{ textAlign: index === 4 || !matches ? 'center' : null, justifyContent: 'center' }}>
                                                        <div className='blu-btn'>
                                                            <Button
                                                                variant="contained"
                                                                onClick={activeStep === 4 ? handleReset : handleNext}
                                                                // disabled={uploadSts}
                                                                disabled={uploadSts || kycLoading === true}
                                                                sx={{ mt: 1, mr: 1 }}
                                                            >
                                                                {index === 4 ? 'Finish' : index === 0 || index === 2 || index === 1 ? "SAVE & CONTINUE" : 'Submit'}

                                                            </Button>
                                                        </div>
                                                        {index !== 0 &&
                                                            // index !== steps.length - 1 && index !== 3 &&
                                                            <div className='blu-btn'>
                                                                <Button
                                                                    onClick={() => (index === 2 && selectDoc === true) ? handleReset2() : handleBack()}
                                                                    sx={{ mt: 1, mr: 1, color: '#fff', display: index === 0 && 'none' }}
                                                                >
                                                                    Back
                                                                </Button>
                                                            </div>
                                                        }
                                                    </div>
                                                </Box>
                                            </StepContent>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Grid>
                            :

                            (userDetailData?.kyc?.status === "Pending" && userDetailData?.kyc?.verify === false) ?
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }} className='kyx-right card-box kyx-right-line'>
                                    <div className='success-box'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                            <path d="M18.6281 87.4993H81.3781C87.7948 87.4993 91.7948 80.541 88.5864 74.9993L57.2114 20.791C54.0031 15.2493 46.0031 15.2493 42.7948 20.791L11.4198 74.9993C8.21144 80.541 12.2114 87.4993 18.6281 87.4993ZM50.0031 58.3327C47.7114 58.3327 45.8364 56.4577 45.8364 54.166V45.8327C45.8364 43.541 47.7114 41.666 50.0031 41.666C52.2948 41.666 54.1698 43.541 54.1698 45.8327V54.166C54.1698 56.4577 52.2948 58.3327 50.0031 58.3327ZM54.1698 74.9993H45.8364V66.666H54.1698V74.9993Z" fill="#FFC107" />
                                        </svg>
                                        <p>Your KYC submission is currently under review. Please wait for admin approval.</p>
                                    </div>
                                </Grid>
                                :
                                (userDetailData?.kyc?.status === "Approved" && userDetailData?.kyc?.verify === true) ?
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }} className='kyx-right card-box kyx-right-line'>
                                        <div className='success-box'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none" >
                                                <g clip-path="url(#clip0_2191_14946)">
                                                    <path d="M50 0C54.5898 0 59.0169 0.585938 63.2812 1.75781C67.5456 2.92969 71.5169 4.6224 75.1953 6.83594C78.8737 9.04948 82.2428 11.6536 85.3027 14.6484C88.3626 17.6432 90.9831 21.0124 93.1641 24.7559C95.3451 28.4993 97.0215 32.487 98.1934 36.7188C99.3652 40.9505 99.9674 45.3776 100 50C100 54.5898 99.4141 59.0169 98.2422 63.2812C97.0703 67.5456 95.3776 71.5169 93.1641 75.1953C90.9505 78.8737 88.3464 82.2428 85.3516 85.3027C82.3568 88.3626 78.9876 90.9831 75.2441 93.1641C71.5007 95.3451 67.513 97.0215 63.2812 98.1934C59.0495 99.3652 54.6224 99.9674 50 100C45.4102 100 40.9831 99.4141 36.7188 98.2422C32.4544 97.0703 28.4831 95.3776 24.8047 93.1641C21.1263 90.9505 17.7572 88.3464 14.6973 85.3516C11.6374 82.3568 9.01693 78.9876 6.83594 75.2441C4.65495 71.5007 2.97852 67.513 1.80664 63.2812C0.634766 59.0495 0.0325521 54.6224 0 50C0 45.4102 0.585938 40.9831 1.75781 36.7188C2.92969 32.4544 4.6224 28.4831 6.83594 24.8047C9.04948 21.1263 11.6536 17.7572 14.6484 14.6973C17.6432 11.6374 21.0124 9.01693 24.7559 6.83594C28.4993 4.65495 32.487 2.97852 36.7188 1.80664C40.9505 0.634766 45.3776 0.0325521 50 0ZM79.4434 33.4473L72.8027 26.8066L40.625 58.9844L27.1973 45.5566L20.5566 52.1973L40.625 72.2656L79.4434 33.4473Z" fill="#28A745" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2191_14946">
                                                        <rect width="100" height="100" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <p>✅ Your KYC has been successfully verified and approved. </p>
                                        </div>

                                    </Grid>
                                    :

                                    null

                    }
                </>

            </Grid>


        </div>
    )
}

export default Kyc
